import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useAppSelector } from "../../app/store/configureStore";
import EFormTable from "./EForm";
import { useCallback, useEffect, useState } from "react";
import { Answers } from "../../app/models/Answers";
import agent from "../../app/api/agent";
import LoadingSpinner from "../../app/common/LoadingSpinner";
import PrintSaveBtns from "../../app/common/PrintSaveBtn";

export default function EducationEdoc() {
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md")
  );
  const { user } = useAppSelector((state) => state.account);
  const [answers, setAnswers] = useState<Answers[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      if (user?.credentialName && user?.portfolioId) {
        const response = await agent.Answers.GetAnswers(
          user.credentialName,
          user.portfolioId,
          "EducationSummary"
        );

        setAnswers(response);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  }, [user?.credentialName, user?.portfolioId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleAnswerChange = (systemCodeId: number, newValue: string) => {
    setAnswers((prevAnswers) =>
      prevAnswers.map((answer) =>
        answer.systemCodeId === systemCodeId
          ? { ...answer, answer: newValue }
          : answer
      )
    );
  };

  const handleSaveDraft = async () => {
    setIsLoading(true);
    // This is just a sample function for demonstration
    const filteredAnswers = answers.filter(
      (answer) => answer.id !== 0 || answer.answer !== ""
    );
    await agent.Answers.InsertorUpdateAnswers(filteredAnswers);
    fetchData();
    setIsLoading(false);
  };
  const handleSave = async () => {
    setIsLoading(true);
    // This is just a sample function for demonstration
    const filteredAnswers = answers.filter(
      (answer) => answer.id !== 0 || answer.answer !== ""
    );
    await agent.Answers.InsertorUpdateAnswers(filteredAnswers);
    fetchData();
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <Grid container p={2} m={1} className="cavas1">
      <Button href="/cdaeducation" startIcon={<ArrowBackIosNewIcon />}>
        Back to Summary of My CDA Education
      </Button>
      <Card
        sx={{
          width: "100%",
          backgroundColor: "cdaEDU.light",
          boxShadow: "0 16px #7DA740",
          marginBottom: 4,
          marginTop: 2,
        }}
      >
        <CardContent>
          <Grid
            item
            xs={10}
            sm={10}
            md={11}
            display="block"
            flexDirection="column"
            paddingLeft={3}
          >
            <Typography variant="h6" fontWeight={700} marginBottom={1}>
              Online Form
            </Typography>
            <Typography display={isMobile ? "none" : "show"} marginBottom={1}>
              <span style={{ fontWeight: 700 }}>Note to Candidate: </span>
              Please use this summary document to show how the collection of
              transcripts, letters, certificates, etc. meet the educational
              requirements for the CDA® Credential. At your CDA Verification
              Visit, your CDA Professional Development (PD) Specialist™ will
              review this sheet to ensure that it accurately reflects your
              education documentation. Please see your CDA®{" "}
              <span style={{ fontStyle: "italic" }}>
                Competency Standards
              </span>{" "}
              book for a detailed explanation of acceptable professional
              education.
            </Typography>
          </Grid>
        </CardContent>
      </Card>
      <Grid item container p={2} spacing={2}>
        <Grid item xs={12}>
          <Typography fontWeight={700} fontSize={18}>
            Candidate
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="First Name"
            defaultValue={user?.firstName}
            variant="filled"
            disabled
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="Last Name"
            defaultValue={user?.lastName}
            variant="filled"
            disabled
            fullWidth
          />
        </Grid>
        <Grid item mt={2} xs={12}>
          <Typography fontWeight={700} fontSize={20}>
            Statements of CDA Education Completion
          </Typography>
          <Typography>
            I attest to completing the required 10 hours of education in each of
            the following CDA Subject Areas.
          </Typography>
        </Grid>
        <EFormTable answersData={answers} onAnswerChange={handleAnswerChange} />
        <PrintSaveBtns
          btnColor={"cdaEDU"}
          title={"OnlineForm"}
          onSave={handleSave}
          onDraft={handleSaveDraft}
        />
      </Grid>
    </Grid>
  );
}
